import React from 'react';
import { Query } from '@apollo/client/react/components';
import CreditCardDetails from '@buyside/components/presentation/UserAccount/BillingInformation/PaymentMethod/creditCardDetails';
import UpdatePaymentMethodBtnContainer from '@buyside/components/presentation/UserAccount/BillingInformation/PaymentMethod/updatePaymentMethodBtnContainer';
import { STRIPE_URL } from '@buyside/util/payment';

import LoadingSpinner, {
  SIZES
} from '@buyside/components/presentation/LoadingSpinner/loadingSpinner';
import { Brand } from '@buyside/components/presentation/UserAccount/BillingInformation/PaymentMethod/util';

import { PaymentMethodDocument, PaymentMethodQuery } from '@interfaces/graphql-typings';
import { useScript } from '@buyside/util/hooks/script';

const PaymentMethodContainer: React.FC<{}> = () => {
  const isStripeLoaded = useScript(STRIPE_URL);

  return (
    <Query<PaymentMethodQuery, {}> query={PaymentMethodDocument}>
      {({ loading, data, error }): React.ReactElement | null => {
        if (error) throw error;
        if (loading || !isStripeLoaded) {
          return (
            <>
              <div />
              <LoadingSpinner size={SIZES.TINY} />
              <div />
            </>
          );
        }

        if (!data || !data.currentUser) return null;

        const { cardDetails } = data.currentUser;

        return (
          <>
            <div>
              {cardDetails ? (
                <CreditCardDetails
                  expiryYear={cardDetails.expiryYear}
                  expiryMonth={cardDetails.expiryMonth}
                  lastFour={cardDetails.lastFour}
                  brand={cardDetails.brand as keyof typeof Brand}
                />
              ) : (
                <div>No credit card on file.</div>
              )}
            </div>
            <UpdatePaymentMethodBtnContainer />
          </>
        );
      }}
    </Query>
  );
};

export default PaymentMethodContainer;
